import React from 'react';
import map from '../../public/imgs/map@2x.jpg';
import Image from '../Image';

const Map = () => {
  return (
    <div>
      <Image image={map} alt="" />
    </div>
  );
};
export default Map;
